import React, { useEffect, useState } from 'react';
type Props = {
  description?: string;
  value: string;
};
export const Flipper = ({ description, value }: Props) => {
  const [oldValue, setOldValue] = useState(value);
  const [latestValue, setLatestValue] = useState(value);
  const [transition, setTransition] = useState('');
  useEffect(() => {
    setOldValue(latestValue);
    setLatestValue(value);

    if (value !== latestValue) {
      setTransition('animate-flipperLeave');
    }
  }, [value]);
  return (
    <span data-testid={value} className="relative isolate">
      {!!description && (
        <span className="sr-only" data-testid="srOnly">
          {description}
        </span>
      )}
      <span
        className={`block text-center ${transition}`}
        data-testid="Flipper-value"
        key={transition}
        onAnimationEnd={(event) => {
          switch (event.animationName) {
            case 'animate-flipperLeave':
              setTransition('animate-flipperEnter');
              break;

            case 'animate-flipperEnter':
              setTransition('animate-flipperEnter');
              break;

            default:
              break;
          }
        }}
      >
        {transition === 'animate-flipperLeave' ? oldValue : latestValue}
      </span>
    </span>
  );
};
